"use client";
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { wrapper, item, link } from './styles.js';
import { Modal } from '../../../Modal/Modal.web.js';
import { Placeholder } from '../../../Placeholder/Placeholder.web.js';
import { HeaderContext } from '../../HeaderContext.js';
import { IconButton } from '../../../IconButton/IconButton.web.js';
import { headerRender } from '../../headerRender.js';
import { IconCross } from '../../../icons/ui_control/IconCross.web.js';
import { colors } from '../../../constants/colors.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MenuModal = function MenuModal(_ref) {
  var menuItems = _ref.menuItems,
    appendToHref = _ref.appendToHref,
    placeholderCount = _ref.placeholderCount,
    loading = _ref.loading,
    opened = _ref.opened,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(HeaderContext.Consumer, null, function (_ref2) {
    var headerProps = _ref2.headerProps,
      colorProps = _ref2.colorProps;
    return /*#__PURE__*/React.createElement(Modal, {
      onClose: onClose,
      opened: opened,
      fullScreen: "both",
      noPadding: true,
      preventClose: true
    }, headerProps ? headerRender(_objectSpread(_objectSpread({}, headerProps), {}, {
      leftComponent: /*#__PURE__*/React.createElement(IconButton, {
        icon: /*#__PURE__*/React.createElement(IconCross, {
          size: 24
        }),
        onClick: onClose,
        color: colorProps.highlightColor,
        status: "plain",
        "aria-label": "Close hamburger menu",
        size: 48
      })
    }), colorProps) : null, /*#__PURE__*/React.createElement(wrapper, null, loading ? _toConsumableArray(Array(placeholderCount)).map(function (_, i) {
      return /*#__PURE__*/React.createElement(item, {
        key: i
      }, /*#__PURE__*/React.createElement(Placeholder, {
        height: "0.75rem",
        width: "12rem"
      }));
    }) : menuItems.map(function (item$1) {
      return /*#__PURE__*/React.createElement(item, {
        key: item$1.key
      }, /*#__PURE__*/React.createElement(link, {
        href: "".concat(item$1.absolute).concat(appendToHref),
        color: colors.inkGrey,
        noUnderline: true
      }, item$1.title));
    })));
  });
};

export { MenuModal };
